import { Navigate } from "react-router-dom";

import { useCapabilities } from "src/hooks/useCapabilities";
import { DashboardPageParams, getUrlToSettingsPage } from "src/router/urls";
import { SettingsSubpages } from "src/settings/SettingsSubpages";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const SettingsPageRedirect: React.FC = () => {
  const { connections, apiKeys, usersPermissions } = useCapabilities();
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();

  if (connections.canAccess) {
    return (
      <Navigate
        to={getUrlToSettingsPage(orgId, wsId, SettingsSubpages.Connections)}
        replace
      />
    );
  }

  if (apiKeys.canAccess) {
    return (
      <Navigate
        to={getUrlToSettingsPage(orgId, wsId, SettingsSubpages.ApiKeys)}
        replace
      />
    );
  }

  if (usersPermissions.canAccess) {
    return (
      <Navigate
        to={getUrlToSettingsPage(orgId, wsId, SettingsSubpages.Users)}
        replace
      />
    );
  }

  return null;
};
